
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pilotKZ",
      function () {
        return require("private-next-pages/pilotKZ/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pilotKZ"])
      });
    }
  